import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "../../../lib/axios";
// import SelectAccount from "react-select"; // NONAKTIF: sumber Salesforce diganti Odoo

const FormCorporateComp = () => {
  const dispatch = useDispatch();
  const dataInputRegistration = useSelector(
    (state) => state.dataInputRegistration
  );
  const [loadingKota, setLoadingKota] = useState(false);
  const [loadingKecamatan, setLoadingKecamatan] = useState(false);
  const [loadingKotaShipping, setLoadingKotaShipping] = useState(false);
  const [loadingKecamatanShipping, setLoadingKecamatanShipping] =
    useState(false);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);
  const [citiesPengiriman, setCitiesPengiriman] = useState([]);
  const [subDistrictsPengiriman, setSubDistrictsPengiriman] = useState([]);

  const [isMitraBaru, setisMitraBaru] = useState(false);
  // === STATE SALESFORCE DINONAKTIFKAN (sumber Nama Perusahaan sekarang Odoo) ===
  // const [searchAccountSf, setsearchAccountSf] = useState(
  //   dataInputRegistration.namaPerusahaan
  // );
  // const [listAccountSf, setlistAccountSf] = useState([]);

  // Autocomplete Nama Perusahaan (sumber: Odoo via /odoo/res-partners)
  const [companyOptions, setCompanyOptions] = useState([]);
  const [loadingCompany, setLoadingCompany] = useState(false);
  const [showCompanyOptions, setShowCompanyOptions] = useState(false);
  const companySearchTimer = useRef(null);

  const kategoriIndustri = [
    "Administrasi pemerintahan, pertahanan dan jaminan sosial wajib",
    "Aktivitas badan internasional dan sejenisnya",
    "Aktivitas industri rumah tangga ",
    "Aktivitas jasa lainnya",
    "Aktivitas keuangan dan asuransi",
    "Aktivitas profesional, ilmiah, dan teknis",
    "Aktivitas sewa guna usaha, ketenagakerjaan, agen perjalanan",
    "Food & Beverage",
    "Industri Barang Kebutuhan Konsumen",
    "Industri pengolahan",
    "Informasi dan komunikasi",
    "Infrastruktur, utilitas, dan transportasi",
    "Kesehatan dan Farmasi",
    "Kesenian, hiburan, dan rekreasi",
    "Konstruksi",
    "NGO",
    "Pendidikan",
    "Pengadaan listrik, gas, uap/air panas dan udara dingin",
    "Pengangkutan dan pergudangan",
    "Penyediaan akomodasi dan penyediaan makan minum",
    "Perdagangan besar dan eceran, reparasi dan perawatan kendaraan",
    "Pertambangan dan penggalian",
    "Real estate",
    "Pertanian, kehutanan, dan perikanan",
  ];

  const handleChangeFormInput = (key, e) => {
    if (key === "SET_PENGIRIMAN_DOKUMEN_PERUSAHAAN") {
      dispatch({ type: key, value: e });
    } else if (key === "SET_FILE_NPWP_PERUSAHAAN") {
      dispatch({ type: key, value: e.target.files[0] });
    } else if (key === "SET_TELEPON_PERUSAHAAN") {
      // Hanya angka yang boleh masuk (mencegah autofill browser mengisi teks)
      dispatch({ type: key, value: e.target.value.replace(/\D/g, "") });
    } else {
      dispatch({ type: key, value: e.target.value });
    }
  };

  const fetchProvinsi = async () => {
    try {
      const options = {
        url: "/locations/states",
        method: "GET",
      };
      const { data } = await axios(options);
      // console.log(data);
      setProvinces(data.provinsi);
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchOneProvinsi = async (flag, idProvinsi) => {
    try {
      const options = {
        url: `/locations/states/${idProvinsi}`,
        method: "GET",
      };
      const { data } = await axios(options);
      if (flag === "first") {
        dispatch({ type: "SET_PROVINSI_PERUSAHAAN", value: data.nama });
      } else {
        dispatch({
          type: "SET_PROVINSI_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
          value: data.nama,
        });
      }
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchKota = async (idProvinsi) => {
    try {
      if (idProvinsi) {
        const options = {
          url: `/locations/cities?stateId=${idProvinsi}`,
          method: "GET",
        };
        const { data } = await axios(options);
        // console.log(data)
        setCities(data.kota_kabupaten);
        setLoadingKota(false);
      }
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchOneKota = async (flag, idKota) => {
    try {
      const options = {
        url: `/locations/cities/${idKota}`,
        method: "GET",
      };
      const { data } = await axios(options);
      if (flag === "first") {
        setLoadingKota(false);
        dispatch({ type: "SET_KOTA_PERUSAHAAN", value: data.nama });
      } else {
        setLoadingKotaShipping(false);
        dispatch({
          type: "SET_KOTA_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
          value: data.nama,
        });
      }
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchSubDistricts = async (idCity) => {
    try {
      if (idCity) {
        const options = {
          url: `/locations/subdistricts?cityId=${idCity}`,
          method: "GET",
        };
        const { data } = await axios(options);
        // console.log(data)
        setSubDistricts(data.kecamatan);
        setLoadingKecamatan(false);
      }
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchOneSubDistricts = async (flag, idSubdistricts) => {
    try {
      const options = {
        url: `/locations/subdistricts/${idSubdistricts}`,
        method: "GET",
      };
      const { data } = await axios(options);
      if (flag === "first") {
        setLoadingKecamatan(false);
        dispatch({ type: "SET_KECAMATAN_PERUSAHAAN", value: data.nama });
      } else {
        setLoadingKecamatanShipping(false);
        dispatch({
          type: "SET_KECAMATAN_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
          value: data.nama,
        });
      }
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchKotaPengiriman = async (idProvinsi) => {
    try {
      if (idProvinsi) {
        const options = {
          url: `/locations/cities?stateId=${idProvinsi}`,
          method: "GET",
        };
        const { data } = await axios(options);
        // console.log(data)
        setCitiesPengiriman(data.kota_kabupaten);
        setLoadingKotaShipping(false);
      }
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchSubDistrictsPengiriman = async (idCity) => {
    try {
      if (idCity) {
        const options = {
          url: `/locations/subdistricts?cityId=${idCity}`,
          method: "GET",
        };
        const { data } = await axios(options);
        // console.log(data)
        setSubDistrictsPengiriman(data.kecamatan);
        setLoadingKecamatanShipping(false);
      }
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const handleChangeProvinsi = (e, flag) => {
    if (flag === "first") {
      dispatch({ type: "SET_PROVINSI_ID_PERUSAHAAN", value: e.target.value });
      fetchOneProvinsi("first", e.target.value);
      fetchKota(e.target.value);
      setLoadingKota(true);
    } else {
      dispatch({
        type: "SET_PROVINSI_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
        value: e.target.value,
      });
      fetchOneProvinsi("second", e.target.value);
      fetchKotaPengiriman(e.target.value);
      setLoadingKotaShipping(true);
    }
  };

  const handleChangeKota = (e, flag) => {
    if (flag === "first") {
      dispatch({ type: "SET_KOTA_ID_PERUSAHAAN", value: e.target.value });
      fetchOneKota("first", e.target.value);
      fetchSubDistricts(e.target.value);
      setLoadingKecamatan(true);
    } else {
      dispatch({
        type: "SET_KOTA_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
        value: e.target.value,
      });
      fetchOneKota("second", e.target.value);
      fetchSubDistrictsPengiriman(e.target.value);
      setLoadingKecamatanShipping(true);
    }
  };

  const handleChangeKecamatan = (e, flag) => {
    if (flag === "first") {
      dispatch({ type: "SET_KECAMATAN_ID_PERUSAHAAN", value: e.target.value });
      fetchOneSubDistricts("first", e.target.value);
    } else {
      dispatch({
        type: "SET_KECAMATAN_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
        value: e.target.value,
      });
      fetchOneSubDistricts("second", e.target.value);
    }
  };

  useEffect(() => {
    fetchProvinsi();
    fetchKota(dataInputRegistration.provinsiIdPerusahaan);
    fetchSubDistricts(dataInputRegistration.kotaIdPerusahaan);
    fetchKotaPengiriman(
      dataInputRegistration.provinsiIdPerusahaanPengirimanDokumen
    );
    fetchSubDistrictsPengiriman(
      dataInputRegistration.kotaIdPerusahaanPengirimanDokumen
    );
  }, []);

  // === FETCH ACCOUNT SALESFORCE DINONAKTIFKAN (diganti Odoo /odoo/res-partners) ===
  // const [loading, setLoading] = useState(false);
  //
  // useEffect(() => {
  //   const fetchAccountSf = async () => {
  //     setLoading(true);
  //     try {
  //       await new Promise((resolve) => setTimeout(resolve, 1000));
  //       const data = await fetch(
  //         `https://sf-services.prasmul-eli.co/api/accounts?account=${searchAccountSf}`
  //       );
  //       const response = await data.json();
  //       response.data.records.map((d) =>
  //         setlistAccountSf((listAccountSf) => [
  //           ...listAccountSf,
  //           {
  //             label: d.Name,
  //             value: d.Id,
  //           },
  //         ])
  //       );
  //
  //       if (response.data.records.length === 0) {
  //         setlistAccountSf([]);
  //         setlistAccountSf((listAccountSf) => [
  //           ...listAccountSf,
  //           {
  //             label: searchAccountSf,
  //             value: searchAccountSf,
  //           },
  //         ]);
  //         dispatch({ type: "SET_NAMA_PERUSAHAAN", value: searchAccountSf });
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //     setLoading(false);
  //   };
  //
  //   if (searchAccountSf !== "") {
  //     fetchAccountSf();
  //   } else {
  //     setlistAccountSf([]);
  //   }
  // }, [searchAccountSf]);
  //
  // const handleChangeNamaPerusahaan = (newValue) => {
  //   setsearchAccountSf(newValue);
  // };
  //
  // const handleSelectChangeNamaPerusahaan = (selectedOption) => {
  //   dispatch({ type: "SET_NAMA_PERUSAHAAN", value: selectedOption.label });
  // };

  // Ambil daftar nama perusahaan dari Odoo lewat route backend /odoo/res-partners
  const fetchResPartners = async (search) => {
    try {
      setLoadingCompany(true);
      const { data } = await axios({
        url: "/odoo/res-partners",
        method: "GET",
        params: { search },
      });
      setCompanyOptions(data?.data || []);
      setShowCompanyOptions(true);
    } catch (err) {
      setCompanyOptions([]);
    } finally {
      setLoadingCompany(false);
    }
  };

  // Dipanggil saat user mengetik di input Nama Perusahaan (debounce 400ms)
  const handleKeyUpNamaPerusahaan = (e) => {
    const value = e.target.value;
    dispatch({ type: "SET_NAMA_PERUSAHAAN", value });

    if (companySearchTimer.current) clearTimeout(companySearchTimer.current);

    const keyword = value.trim();
    if (keyword.length < 3) {
      setCompanyOptions([]);
      setShowCompanyOptions(false);
      return;
    }

    companySearchTimer.current = setTimeout(() => {
      fetchResPartners(keyword);
    }, 400);
  };

  // Saat user memilih salah satu saran nama perusahaan
  const handlePickNamaPerusahaan = (name) => {
    dispatch({ type: "SET_NAMA_PERUSAHAAN", value: name });
    setShowCompanyOptions(false);
    setCompanyOptions([]);
  };

  // console.log(dataInputRegistration.namaPerusahaan)

  return (
    <>
      <p style={{ fontSize: "16px", fontWeight: "400", marginBottom: "2%" }}>
        1. Silahkan lengkapi data profil perusahaan berikut.
      </p>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className='col-lg-6'>
          <label htmlFor='NamaPerusahaan' className="form-label required" style={{ fontSize: '16px', fontWeight: '600', color: (dataInputRegistration.namaPerusahaan.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}>Nama Perusahaan</label>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              id='NamaPerusahaan'
              className="form-control mb-2"
              placeholder='Nama Perusahaan'
              autoComplete="off"
              onChange={handleKeyUpNamaPerusahaan}
              onFocus={() => { if (companyOptions.length > 0) setShowCompanyOptions(true); }}
              onBlur={() => setTimeout(() => setShowCompanyOptions(false), 150)}
              value={dataInputRegistration.namaPerusahaan}
              style={{ borderColor: (dataInputRegistration.namaPerusahaan.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
            />
            {showCompanyOptions && (loadingCompany || companyOptions.length > 0) && (
              <ul
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  zIndex: 1000,
                  margin: '-6px 0 0 0',
                  padding: 0,
                  listStyle: 'none',
                  background: '#fff',
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                  maxHeight: '220px',
                  overflowY: 'auto',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
                }}
              >
                {loadingCompany && (
                  <li style={{ padding: '8px 12px', fontSize: '14px', color: '#888' }}>Mencari...</li>
                )}
                {!loadingCompany && companyOptions.length === 0 && (
                  <li style={{ padding: '8px 12px', fontSize: '14px', color: '#888' }}>Tidak ditemukan</li>
                )}
                {!loadingCompany && companyOptions.map((opt) => (
                  <li
                    key={opt.id}
                    onMouseDown={() => handlePickNamaPerusahaan(opt.name)}
                    style={{ padding: '8px 12px', cursor: 'pointer', fontSize: '14px', borderBottom: '1px solid #f1f1f1' }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = '#f5f7fa')}
                    onMouseLeave={(e) => (e.currentTarget.style.background = '#fff')}
                  >
                    {opt.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <p style={{ fontSize: '12px', fontWeight: '400' }}>Contoh: Maju Abadi</p>
        </div>
        {/*
        <div className="col-lg-6">
          <label
            htmlFor="NamaPerusahaan"
            className="form-label required"
            style={{ fontSize: "16px", fontWeight: "600" }}
          >
            Nama Perusahaan
          </label>
          <SelectAccount
            value={listAccountSf.find(
              (option) => option.label === searchAccountSf
            )}
            options={listAccountSf}
            onInputChange={handleChangeNamaPerusahaan}
            onChange={handleSelectChangeNamaPerusahaan}
            isSearchable
            isLoading={loading}
            placeholder="Masukkan Nama Perusahaan"
          />
          <p style={{ fontSize: "12px", fontWeight: "400", marginTop: "5px" }}>
            Contoh: Maju Abadi{" "}
            <small style={{ color: "#0C86D9", fontWeight: 400 }}>
              <i>(Nama Perusahaan sesuaikan dengan NPWP)</i>
            </small>
          </p>
        </div>
        */}

        <div className="col-lg-6 col-12">
          <label
            htmlFor="jenisPerusahaan"
            className="form-label required"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.jenisPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Jenis Perusahaan
          </label>
          <select
            className="form-select"
            aria-label="Select example"
            id="jenisPerusahaan"
            onChange={(e) => handleChangeFormInput("SET_JENIS_PERUSAHAAN", e)}
            value={dataInputRegistration.jenisPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.jenisPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            <option value="">Pilih</option>
            <option value="PT">PT (Perseroan Terbatas)</option>
            <option value="CV">CV (Persekutuan Komanditer)</option>
            <option value="BUMN">Perusahaan Negara</option>
            <option value="Koperasi">Koperasi</option>
            <option value="Persero">Persero</option>
            <option value="Perseorangan">Perusahaan Perseorangan</option>
            <option value="Firma">Persekutuan Firma</option>
            <option value="Yayasan">Yayasan</option>
          </select>
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <label
            htmlFor="KlasifikasiIndustri"
            className="form-label required"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.klasifikasiIndustri.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Klasifikasi Industri
          </label>
          {/* <input type="text" id='KlasifikasiIndustri' className="form-control mb-2" placeholder='Klasifikasi Industri' onChange={(e) => handleChangeFormInput('SET_KLASIFIKASI_INDUSTRI', e)} value={dataInputRegistration.klasifikasiIndustri}
                        style={{ borderColor: (dataInputRegistration.klasifikasiIndustri.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
                    /> */}
          <select
            className="form-select"
            aria-label="Select example"
            id="KlasifikasiIndustri"
            onChange={(e) =>
              handleChangeFormInput("SET_KLASIFIKASI_INDUSTRI", e)
            }
            value={dataInputRegistration.klasifikasiIndustri}
            style={{
              borderColor:
                dataInputRegistration.klasifikasiIndustri.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            <option value="">Pilih</option>
            <option value="Other">Lainnya</option>
            {kategoriIndustri.map((k, i) => (
              <option
                key={i}
                value={k}
                selected={dataInputRegistration.klasifikasiIndustri === k}
              >
                {k}
              </option>
            ))}
          </select>
          {dataInputRegistration.klasifikasiIndustri === "Other" ? (
            <input
              type="text"
              id="KlasifikasiIndustriOther"
              className="form-control mt-1 mb-3"
              placeholder="Klasifikasi Industri"
              onChange={(e) =>
                handleChangeFormInput("SET_KLASIFIKASI_INDUSTRI_OTHER", e)
              }
              value={dataInputRegistration.klasifikasiIndustriOther}
              style={{
                borderColor:
                  dataInputRegistration.klasifikasiIndustriOther.length === 0 &&
                    dataInputRegistration.inputAlert === true
                    ? "#F1416C"
                    : "",
              }}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <label
            htmlFor="StringNpwpPerusahaan"
            className="form-label required"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.stringNpwpPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            No. NPWP Perusahaan
          </label>
          <input
            type="text"
            id="StringNpwpPerusahaan"
            className="form-control mb-2"
            placeholder="No. NPWP Perusahaan"
            onChange={(e) =>
              handleChangeFormInput("SET_STRING_NPWP_PERUSAHAAN", e)
            }
            value={dataInputRegistration.stringNpwpPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.stringNpwpPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          />
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <label
            htmlFor="FileNpwpPerusahaan"
            className="form-label required"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.fileNpwpPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Upload NPWP
          </label>
          <input
            type="file"
            id="FileNpwpPerusahaan"
            className="form-control mb-2"
            onChange={(e) =>
              handleChangeFormInput("SET_FILE_NPWP_PERUSAHAAN", e)
            }
            style={{
              borderColor:
                dataInputRegistration.fileNpwpPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          />
          <p style={{ fontSize: "12px", fontWeight: "400" }}>
            File format .JPG, .JPEG, .PNG, .PDF
          </p>
          {dataInputRegistration.fileNpwpPerusahaan ? (
            <div className="mb-2" style={{ color: "#26D07C" }}>
              {dataInputRegistration.fileNpwpPerusahaan &&
                `${dataInputRegistration.fileNpwpPerusahaan.name} - ${dataInputRegistration.fileNpwpPerusahaan.type}`}
            </div>
          ) : (
            ""
          )}
          <small style={{ color: "#0C86D9", fontWeight: 400 }}>
            <b>*Disclaimer</b>
            <br></br>
            <i>
              Data dan informasi yang Anda berikan bersifat rahasia <br></br>dan
              hanya akan digunakan untuk kepentingan administrasi, <br></br>{" "}
              pendaftaran, dan promosi dari prasmul-eli
            </i>
          </small>
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <label
            htmlFor="TeleponPerusahaan"
            className="form-label required"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.teleponPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Telepon Perusahaan
          </label>
          <input
            type="text"
            id="TeleponPerusahaan"
            name="teleponPerusahaan"
            autoComplete="off"
            inputMode="numeric"
            className="form-control mb-2"
            placeholder="Telepon Perusahaan"
            onChange={(e) => handleChangeFormInput("SET_TELEPON_PERUSAHAAN", e)}
            value={dataInputRegistration.teleponPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.teleponPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          />
          <p style={{ fontSize: "12px", fontWeight: "400" }}>
            Contoh: 021 77122456
          </p>
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12 mb-2">
          <label
            className="form-label required"
            style={{ fontSize: "16px", fontWeight: "600" }}
          >
            Alamat Perusahaan
          </label>
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="Provinsi"
            className="form-label"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.provinsiIdPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Provinsi
          </label>
          <select
            className="form-select"
            aria-label="Select example"
            id="Provinsi"
            onChange={(e) => handleChangeProvinsi(e, "first")}
            value={dataInputRegistration.provinsiIdPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.provinsiIdPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            <option value="">Pilih</option>
            {provinces.map((p, i) => (
              <option key={i} value={p.id}>
                {p.nama}
              </option>
            ))}
          </select>
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="Kota"
            className="form-label"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.kotaIdPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            {loadingKota === true ? "Loading.." : "Kota"}
          </label>
          <select
            className="form-select"
            aria-label="Select example"
            id="Kota"
            onChange={(e) => handleChangeKota(e, "first")}
            value={dataInputRegistration.kotaIdPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.kotaIdPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            <option value="">Pilih</option>
            {cities.map((c, i) => (
              <option key={i} value={c.id}>
                {c.nama}
              </option>
            ))}
          </select>
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="Kecamatan"
            className="form-label"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.kecamatanIdPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            {loadingKecamatan === true ? "Loading.." : "Kecamatan"}
          </label>
          <select
            className="form-select"
            aria-label="Select example"
            id="Kecamatan"
            onChange={(e) => handleChangeKecamatan(e, "first")}
            value={dataInputRegistration.kecamatanIdPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.kecamatanIdPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            <option value="">Pilih</option>
            {subDistricts.map((d, i) => (
              <option key={i} value={d.id}>
                {d.nama}
              </option>
            ))}
          </select>
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="Kodepos"
            className="form-label"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.kodeposPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Kode Pos
          </label>
          <input
            type="text"
            id="Kodepos"
            className="form-control mb-2"
            placeholder="Kode Pos"
            onChange={(e) => handleChangeFormInput("SET_KODEPOS_PERUSAHAAN", e)}
            value={dataInputRegistration.kodeposPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.kodeposPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          />
        </div>
        <div className="col-lg-8 col-12">
          <label
            htmlFor="PatokanPerusahaan"
            className="form-label"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.patokanPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Nama Jalan, Gedung, Nomor/Blok
          </label>
          <input
            type="text"
            id="PatokanPerusahaan"
            className="form-control mb-2"
            placeholder="Nama Jalan, Gedung, Nomor/Blok"
            onChange={(e) => handleChangeFormInput("SET_PATOKAN_PERUSAHAAN", e)}
            value={dataInputRegistration.patokanPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.patokanPerusahaan.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          />
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <div className="form-check form-check-custom form-check-solid">
            <input
              style={{
                backgroundColor:
                  dataInputRegistration.pengirimanDokumenKeAlamatPerusahaan ===
                    false
                    ? "#FFFFFF"
                    : "",
              }}
              className="form-check-input"
              type="checkbox"
              defaultValue
              id="flexCheckDefault"
              onClick={(e) =>
                handleChangeFormInput(
                  "SET_PENGIRIMAN_DOKUMEN_PERUSAHAAN",
                  dataInputRegistration.pengirimanDokumenKeAlamatPerusahaan ===
                    true
                    ? false
                    : true
                )
              }
              checked={
                dataInputRegistration.pengirimanDokumenKeAlamatPerusahaan
              }
            />
            <label
              className="form-check-label"
              htmlFor="flexCheckDefault"
              style={{ fontSize: "16px", fontWeight: "600" }}
            >
              Alamat Pengiriman Dokumen berbeda dengan Alamat Perusahaan
            </label>
          </div>
          {dataInputRegistration.pengirimanDokumenKeAlamatPerusahaan ===
            true ? (
            <div
              className="row"
              style={{ marginTop: "2%", marginLeft: "20px" }}
            >
              <div className="col-lg-11 col-12 mb-2">
                <label
                  className="form-label required"
                  style={{ fontSize: "16px", fontWeight: "600" }}
                >
                  Alamat Pengiriman Dokumen
                </label>
              </div>
              <div className="col-lg-4 col-12">
                <label
                  htmlFor="ProvinsiPengirimanDokumen"
                  className="form-label"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color:
                      dataInputRegistration
                        .provinsiIdPerusahaanPengirimanDokumen.length === 0 &&
                        dataInputRegistration.inputAlert === true
                        ? "#F1416C"
                        : "",
                  }}
                >
                  Provinsi
                </label>
                <select
                  className="form-select"
                  aria-label="Select example"
                  id="ProvinsiPengirimanDokumen"
                  onChange={(e) => handleChangeProvinsi(e, "second")}
                  value={
                    dataInputRegistration.provinsiIdPerusahaanPengirimanDokumen
                  }
                  style={{
                    borderColor:
                      dataInputRegistration
                        .provinsiIdPerusahaanPengirimanDokumen.length === 0 &&
                        dataInputRegistration.inputAlert === true
                        ? "#F1416C"
                        : "",
                  }}
                >
                  <option value="">Pilih</option>
                  {provinces.map((p, i) => (
                    <option key={i} value={p.id}>
                      {p.nama}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-4 col-12">
                <label
                  htmlFor="KotaPengirimanDokumen"
                  className="form-label"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color:
                      dataInputRegistration.kotaIdPerusahaanPengirimanDokumen
                        .length === 0 &&
                        dataInputRegistration.inputAlert === true
                        ? "#F1416C"
                        : "",
                  }}
                >
                  {loadingKotaShipping === true ? "Loading.." : "Kota"}
                </label>
                <select
                  className="form-select"
                  aria-label="Select example"
                  id="KotaPengirimanDokumen"
                  onChange={(e) => handleChangeKota(e, "second")}
                  value={
                    dataInputRegistration.kotaIdPerusahaanPengirimanDokumen
                  }
                  style={{
                    borderColor:
                      dataInputRegistration.kotaIdPerusahaanPengirimanDokumen
                        .length === 0 &&
                        dataInputRegistration.inputAlert === true
                        ? "#F1416C"
                        : "",
                  }}
                >
                  <option value="">Pilih</option>
                  {citiesPengiriman.map((p, i) => (
                    <option key={i} value={p.id}>
                      {p.nama}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-4 col-12">
                <label
                  htmlFor="KecamatanPengirimanDokumen"
                  className="form-label"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color:
                      dataInputRegistration
                        .kecamatanIdPerusahaanPengirimanDokumen.length === 0 &&
                        dataInputRegistration.inputAlert === true
                        ? "#F1416C"
                        : "",
                  }}
                >
                  {loadingKecamatanShipping === true
                    ? "Loading.."
                    : "Kecamatan"}
                </label>
                <select
                  className="form-select"
                  aria-label="Select example"
                  id="KecamatanPengirimanDokumen"
                  onChange={(e) => handleChangeKecamatan(e, "second")}
                  value={
                    dataInputRegistration.kecamatanIdPerusahaanPengirimanDokumen
                  }
                  style={{
                    borderColor:
                      dataInputRegistration
                        .kecamatanIdPerusahaanPengirimanDokumen.length === 0 &&
                        dataInputRegistration.inputAlert === true
                        ? "#F1416C"
                        : "",
                  }}
                >
                  <option value="">Pilih</option>
                  {subDistrictsPengiriman.map((p, i) => (
                    <option key={i} value={p.id}>
                      {p.nama}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-4 col-12">
                <label
                  htmlFor="KodeposPengirimanDokumen"
                  className="form-label"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color:
                      dataInputRegistration.kodeposPerusahaanPengirimanDokumen
                        .length === 0 &&
                        dataInputRegistration.inputAlert === true
                        ? "#F1416C"
                        : "",
                  }}
                >
                  Kode Pos
                </label>
                <input
                  type="text"
                  id="KodeposPengirimanDokumen"
                  className="form-control mb-2"
                  placeholder="Kode Pos"
                  onChange={(e) =>
                    handleChangeFormInput(
                      "SET_KODEPOS_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
                      e
                    )
                  }
                  value={
                    dataInputRegistration.kodeposPerusahaanPengirimanDokumen
                  }
                  style={{
                    borderColor:
                      dataInputRegistration.kodeposPerusahaanPengirimanDokumen
                        .length === 0 &&
                        dataInputRegistration.inputAlert === true
                        ? "#F1416C"
                        : "",
                  }}
                />
              </div>
              <div className="col-lg-8 col-12">
                <label
                  htmlFor="PatokanPerusahaanPengirimanDokumen"
                  className="form-label"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color:
                      dataInputRegistration.patokanPerusahaanPengirimanDokumen
                        .length === 0 &&
                        dataInputRegistration.inputAlert === true
                        ? "#F1416C"
                        : "",
                  }}
                >
                  Nama Jalan, Gedung, Nomor/Blok
                </label>
                <input
                  type="text"
                  id="PatokanPerusahaanPengirimanDokumen"
                  className="form-control mb-2"
                  placeholder="Nama Jalan, Gedung, Nomor/Blok"
                  onChange={(e) =>
                    handleChangeFormInput(
                      "SET_PATOKAN_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
                      e
                    )
                  }
                  value={
                    dataInputRegistration.patokanPerusahaanPengirimanDokumen
                  }
                  style={{
                    borderColor:
                      dataInputRegistration.patokanPerusahaanPengirimanDokumen
                        .length === 0 &&
                        dataInputRegistration.inputAlert === true
                        ? "#F1416C"
                        : "",
                  }}
                />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default FormCorporateComp;
